<template>
  <h2 style="text-align: center;">Arts</h2>
  <MDBTabs v-model="controlName">
    <MDBTabNav tabsClasses="mb-3">
      <MDBTabItem tabId="EditArt" href="EditArt">Edit Art</MDBTabItem>
      <MDBTabItem tabId="EditArtCategories" href="EditArtCategories">Edit Art Categories</MDBTabItem>
      <MDBTabItem tabId="EditSvgArtCategories" href="EditSvgArtCategories">Edit Svg Art Categories</MDBTabItem>
      <MDBTabItem tabId="AddSvgArt" href="AddSvgArt">Add Svg Art</MDBTabItem>
    </MDBTabNav>
    <MDBTabContent>
      <MDBTabPane tabId="EditArt">
        <form class="card col-md-8 offset-md-2">
          <div class="row p-2">
            <div class="col-md-4">
              <label class="form-text"> DST File </label>
              <input
                type="file"
                id="file"
                class="form-control custom-file-input"
                accept=".dst, .zip"
                multiple
                @change="uploadNewArt($event)"
              />
            </div>
            
            <div class="col-md-3">
              <label class="form-text"></label>
              <MDBInput label="Art Name" v-model="artName" />
            </div>
            <div class="col-md-3">
              <label class="form-text"></label>
              <MDBInput label="Size Name" v-model="artSizeName" />
            </div>
            <div class="col-md-3">
              <label class="form-text">Art Category</label>
              <vue-select
              title="Choose font type"
              :close-on-select="true"
              :min="1"
              :options="store.getAllArtCategories()"
              label-by="categoryName"
              value-by="categoryID"
              searchable
              :model-value="artCategoryID"
              @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
                artCategoryID = value
              }
              }"
            >
            </vue-select>
            </div>
            <div class="col-md-2 p-3" title="Add new art" style="display: flex; justify-content: center; gap: 20px;">
              <icon-svg
                icon="material-symbols:add-circle-outline"
                :height="35"
                :width="35"
                 style="cursor: pointer"
                @click="newArt()"
              />
              <div v-if="isLoading == true" style="display: grid; justify-items: center;"><span>Sending...</span><MDBSpinner /></div>
            </div>
          </div>
        </form>
        
  <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <th>Art Name</th>
            <th>Preview</th>
            <th>Sizes</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(art, index) in store.getAllArts()" :key="index">
            <td>{{ art.artName }}</td>
            <td>
              <div
                style="
                  position: relative;
                  justify-content: center;
                  display: flex;
                "
              >
                <DSTPreview
                  style="position: relative"
                  :dwidth="
                    (47.0 *
                      art.sizes[Object.keys(art.sizes)[0]].dstfile.pixelWidth) /
                    art.sizes[Object.keys(art.sizes)[0]].dstfile.pixelHeight
                  "
                  :dheight="47.0"
                  :dstFile="art.sizes[Object.keys(art.sizes)[0]].dstfile"
                  :layersColors="art.defaultColors"
                  :left="0"
                  :top="0"
                >
                </DSTPreview>
              </div>
            </td>
            <td>{{ GetAllSizesNames(art) }}</td>
            <td>
              <icon-svg
                icon="line-md:edit"
                :height="25"
                :width="25"
                style="cursor: pointer"
                @click="(editArtPopup = true), editArt(art)"
              />
            </td>
            <td>
              <icon-svg
                icon="ic:baseline-delete"
                :height="25"
                :width="25"
                style="cursor: pointer"
                @click="removeArt(art.artID)"
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="columns">
    <template>
      <div class="column is-2"></div>
      <span>&nbsp;</span>
    </template>
  </div>



  <MDBModal
    id="editArtPopup"
    tabindex="-1"
    labelledby="editArtPopupLabel"
    v-model="editArtPopup"
    centered
    scrollable
    ><MDBModalHeader>
      <MDBModalTitle id="editArtPopupLabel" :style="{ width: '100%' }">
        <div style="width: 100%; display: block">
          <span class="popup-title">
            <h4>
              {{ ArtToPopup.artName }}
            </h4>
          </span>
          <span class="category-select">
            <vue-select
            title="Choose font type"
            :close-on-select="true"
            :min="1"
            :options="store.getAllArtCategories()"
            label-by="categoryName"
            value-by="categoryID"
            searchable
            :model-value="ArtToPopup.artCategoryID"
            @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
                ArtToPopup.artCategoryID = value
              }
            }"
            >
          </vue-select>
        </span>
        </div>
      </MDBModalTitle>
    </MDBModalHeader>
    <MDBModalBody style="overflow-y: auto">
      <div>
        <div class="row">
          <div class="col-md-6">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Size Name</th>
                  <th>Size of size</th>
                  <th v-if="ArtToPopup.sizes.length > 1">to delete</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(size, index) in store.getAllArtSizes(
                    ArtToPopup.artID
                  )"
                  :key="index"
                >
                  <td>
                    <input
                      class="form-control"
                      type="text"
                      v-model="size.sizeName"
                    />
                  </td>
                  <td>
                    {{ size.dstfile.pixelWidth }}
                    X
                    {{ size.dstfile.pixelHeight }}
                  </td>
                  <td>
                    <icon-svg
                      icon="ic:baseline-delete"
                      :height="25"
                      :width="25"
                      style="cursor: pointer"
                      @click="removeSize(ArtToPopup.artID, size.sizeID)"
                    />
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <input
                      class="form-control"
                      type="text"
                      v-model="newArtSizeName"
                    />
                  </td>
                  <td>
                    <input
                      type="file"
                      id="file"
                      class="form-control custom-file-input"
                      @change="uploadNewArtSize($event)"
                    />
                  </td>
                  <td>
                    <div title="Add art size">
                      <icon-svg
                        icon="carbon:add-alt"
                        :height="25"
                        :width="25"
                        style="cursor: pointer"
                        @click="addArtSizeToStore()"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="showWaitMessage == true" style="color: red; font-size: 26px;">Wait!</div>
          </div>
          <div class="col-md-6 card">
            <div class="row card-img-top prevArt">
              <DSTPreview
                :dwidth="
                  (100.0 *
                    ArtToPopup.sizes[Object.keys(ArtToPopup.sizes)[0]].dstfile
                      .pixelWidth) /
                  ArtToPopup.sizes[Object.keys(ArtToPopup.sizes)[0]].dstfile
                    .pixelHeight
                "
                :dheight="100"
                :dstFile="
                  ArtToPopup.sizes[Object.keys(ArtToPopup.sizes)[0]].dstfile
                "
                :layersColors="ArtToPopup.defaultColors"
                left="10"
                top="10"
              >
              </DSTPreview>
            </div>
            <!-- <div class="form-outline propLine">
                      <div class="colors-select-line" ref="colorsSelectLineRef">
                        <div v-for="(layer, index) in ArtToPopup.defaultColors" :key="index">
                         <SelectColor v-model="currentArtColors[index]">
                      </SelectColor>
                        </div>
                      </div>
                    </div> -->
            <div class="row card-body">
              <div
                class="divider dropdown"
                style="width: 200px; margin-top: 120px"
              >
                <div
                  v-for="(layer, index) in ArtToPopup.defaultColors"
                  :key="index"
                >
                  <vue-select
                    :close-on-select="true"
                    :min="1"
                    :options="store.getAllColors()"
                    label-by="colorName"
                    searchable
                    :model-value="currentArtColors[index]"
                    @update:modelValue="(value) => {
                      if (value !== null && value !== undefined) { 
                      currentArtColors[index] = value
                      setColor(index, value);
                      }
                    }"
                  >
                    <template #label="{ selected }">
                      <template v-if="selected">
                        <div class="dd-color">
                          <span class="select-color-name" :style="{ backgroundColor: selected.color }">
                          </span>
                          {{ selected.colorName }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="dd-color">
                          <span class="select-color-name"
                            :style="{
                              backgroundColor:
                                store.allColors.value[ArtToPopup.defaultColors[index]]
                                  .color,
                            }"
                          >
                          </span>

                          {{
                            store.allColors.value[ArtToPopup.defaultColors[index]]
                              .colorName
                          }}
                        </div>
                      </template>
                    </template>
                    <template #dropdown-item="{ option }">
                      <div class="dd-color">
                        <span class="select-color-name" :style="{ backgroundColor: option.color }">
                        </span>
                        {{ option.colorName }}
                      </div>
                    </template>
                  </vue-select>
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MDBModalBody>
    <MDBModalFooter>
      <MDBBtn color="secondary" @click="editArtPopup = false">Close</MDBBtn>
    </MDBModalFooter>
  </MDBModal>
    <MDBModal
    id="editArtSvgPopup"
    tabindex="-1"
    labelledby="editArtSvgPopupLabel"
    v-model="editArtSvgPopup"
    centered
    scrollable
    ><MDBModalHeader>
      <MDBModalTitle id="editArtSvgPopupLabel" :style="{ width: '100%' }">
        <div style="width: 100%; display: block">
          <span class="popup-title">
            <h4>
              {{ ArtToPopup.artName }}
            </h4>
          </span>
          <span class="category-select">
            <vue-select
            title="Choose font type"
            :close-on-select="true"
            :min="1"
            :options="store.getAllArtCategories()"
            label-by="categoryName"
            value-by="categoryID"
            searchable
            :model-value="ArtToPopup.artCategoryID"
            @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
                ArtToPopup.artCategoryID = value
              }
            }"
            >
          </vue-select>
        </span>
        </div>
      </MDBModalTitle>
    </MDBModalHeader>
    <MDBModalBody style="overflow-y: auto">
      <div>
        <div class="row">
          <!-- <div class="col-md-6">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Size Name</th>
                  <th>Size of size</th>
                  <th v-if="ArtToPopup.sizes.length > 1">to delete</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(size, index) in store.getAllArtSizes(
                    ArtToPopup.artID
                  )"
                  :key="index"
                >
                  <td>
                    <input
                      class="form-control"
                      type="text"
                      v-model="size.sizeName"
                    />
                  </td>
                  <td>
                    {{ size.dstfile.pixelWidth }}
                    X
                    {{ size.dstfile.pixelHeight }}
                  </td>
                  <td>
                    <icon-svg
                      icon="ic:baseline-delete"
                      :height="25"
                      :width="25"
                      style="cursor: pointer"
                      @click="removeSize(ArtToPopup.artID, size.sizeID)"
                    />
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <input
                      class="form-control"
                      type="text"
                      v-model="newArtSizeName"
                    />
                  </td>
                  <td>
                    <input
                      type="file"
                      id="file"
                      class="form-control custom-file-input"
                      @change="uploadNewArtSize($event)"
                    />
                  </td>
                  <td>
                    <div title="Add art size">
                      <icon-svg
                        icon="carbon:add-alt"
                        :height="25"
                        :width="25"
                        style="cursor: pointer"
                        @click="addArtSizeToStore()"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="showWaitMessage == true" style="color: red; font-size: 26px;">Wait!</div>
          </div> -->
          <div class="col-md-6 card">
            <div class="row card-img-top prevArt">
              {{ ArtToPopup }}
               <svg style="width: 100%; height: 100%">
                                                            <image :href="`${
                                  store.baseURL
                                }/${store.allArtsSVG.value[
                                  ArtToPopup.artID
                                ].svgFile.relativePath.replaceAll(
                                  '\\',
                                  '\\\\'
                                )}`" :filter="`url(#ColorFilter-${ArtToPopup.colors[0]})`" />
                                                        </svg>
              <!-- <DSTPreview
                :dwidth="
                  (100.0 *
                    ArtToPopup.sizes[Object.keys(ArtToPopup.sizes)[0]].dstfile
                      .pixelWidth) /
                  ArtToPopup.sizes[Object.keys(ArtToPopup.sizes)[0]].dstfile
                    .pixelHeight
                "
                :dheight="100"
                :dstFile="
                  ArtToPopup.sizes[Object.keys(ArtToPopup.sizes)[0]].dstfile
                "
                :layersColors="ArtToPopup.defaultColors"
                left="10"
                top="10"
              >
              </DSTPreview> -->
            </div>
            
            <div class="row card-body">
              <div
                class="divider dropdown"
                style="width: 200px; margin-top: 120px"
              >
                <div
                  v-for="(layer, index) in ArtToPopup.defaultColors"
                  :key="index"
                >
                  <vue-select
                    :close-on-select="true"
                    :min="1"
                    :options="store.getAllColors()"
                    label-by="colorName"
                    searchable
                    :model-value="currentArtColors[index]"
                    @update:modelValue="(value) => {
                      if (value !== null && value !== undefined) { 
                      currentArtColors[index] = value
                      setColor(index, value);
                      }
                    }"
                  >
                    <template #label="{ selected }">
                      <template v-if="selected">
                        <div class="dd-color">
                          <span class="select-color-name" :style="{ backgroundColor: selected.color }">
                          </span>
                          {{ selected.colorName }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="dd-color">
                          <span class="select-color-name"
                            :style="{
                              backgroundColor:
                                store.allColors.value[ArtToPopup.defaultColors[index]]
                                  .color,
                            }"
                          >
                          </span>

                          {{
                            store.allColors.value[ArtToPopup.defaultColors[index]]
                              .colorName
                          }}
                        </div>
                      </template>
                    </template>
                    <template #dropdown-item="{ option }">
                      <div class="dd-color">
                        <span class="select-color-name" :style="{ backgroundColor: option.color }">
                        </span>
                        {{ option.colorName }}
                      </div>
                    </template>
                  </vue-select>
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MDBModalBody>
    <MDBModalFooter>
      <MDBBtn color="secondary" @click="editArtSvgPopup = false">Close</MDBBtn>
    </MDBModalFooter>
  </MDBModal>
      </MDBTabPane>
      <MDBTabPane tabId="EditArtCategories">
        <form class="card col-md-6 offset-md-3">
    <div class="row p-2">
      <div class="col-md-4">
        <label class="form-text"> Category Name </label>
        <input class="form-control" type="text" v-model="categoryName" />
      </div>
      <div class="col-md-2 p-3" title="Add category">
        <icon-svg
          icon="material-symbols:add-circle-outline"
          :height="35"
          :width="35"
          style="cursor: pointer"
          @click="addArtCategory()"
        />
      </div>
    </div>
  </form>
        <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <td>Category ID</td>
            <td>Category Name</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(col, index) in store.getAllArtCategories().filter(f => f.categoryName != 'More' && f.categoryName != 'My Arts')" :key="index">
            <td>{{ col.categoryID }}</td>
            <td>{{ col.categoryName }}</td>
            <td>
              <icon-svg
                icon="ic:baseline-delete"
                :height="25"
                :width="25"
                style="cursor: pointer"
                @click="removeCategory(col.categoryID)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
      </MDBTabPane>
      
      <MDBTabPane tabId="EditSvgArtCategories">
        <form class="card col-md-6 offset-md-3">
    <div class="row p-2">
      <div class="col-md-4">
        <label class="form-text"> Category Name </label>
        <input class="form-control" type="text" v-model="categoryName" />
      </div>
      <div class="col-md-2 p-3" title="Add category">
        <icon-svg
          icon="material-symbols:add-circle-outline"
          :height="35"
          :width="35"
          style="cursor: pointer"
          @click="addSvgArtCategory()"
        />
      </div>
    </div>
  </form>
        <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <td>Category ID</td>
            <td>Category Name</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(col, index) in store.getAllSvgArtCategories().filter(f => f.categoryName != 'More' && f.categoryName != 'My Arts')" :key="index">
            <td>{{ col.categoryID }}</td>
            <td>{{ col.categoryName }}</td>
            <td>
              <icon-svg
                icon="ic:baseline-delete"
                :height="25"
                :width="25"
                style="cursor: pointer"
                @click="removeSvgArtCategory(col.categoryID)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
      </MDBTabPane>
      <MDBTabPane tabId="AddSvgArt">
        <!-- טופס הוספת SVG Art בלבד (ללא עריכה) -->
        <form class="card col-md-8 offset-md-2">
          <div class="row p-2">
            <div class="col-md-4">
              <label class="form-text"> SVG File </label>
              <input
                type="file"
                id="file"
                class="form-control custom-file-input"
                accept=".svg, .zip"
                multiple
                @change="uploadNewArtSvg($event)" 
              />
            </div>
            <div class="col-md-3">
              <label class="form-text"></label>
              <MDBInput label="Svg Art Name" v-model="artNameSvg" />
            </div>
            <div class="col-md-3">
              <label class="form-text">Art Category</label>
              <vue-select
              title="Choose font type"
              :close-on-select="true"
              :min="1"
              :options="store.getAllArtCategories()"
              label-by="categoryName"
              value-by="categoryID"
              searchable
              :model-value="artCategoryIDSvg"
              @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
                artCategoryIDSvg = value
              }
              }"
            >
            </vue-select>
            </div>
            <div class="col-md-2 p-3" title="Add new art" style="display: flex; cursor: pointer;  justify-content: center; gap: 20px;">
              <icon-svg
                icon="material-symbols:add-circle-outline"
                :height="35"
                :width="35"
                @click="saveSvgArt()"
              />
              <div v-if="isLoading == true" style="display: grid; justify-items: center;"><span>Sending...</span><MDBSpinner /></div>
            </div>
          </div>
        </form>
        <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <th>Art Name</th>
            <th>Preview</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="art in store.getAllSvgArts()" :key="art.artID">
            <!-- <tr v-for="(art, index) in store.getAllSvgArts()" :key="art.artID"></tr> -->
            <td>{{ art.artName }}</td>
            <td>
              <div
                style="
                  position: relative;
                  justify-content: center;
                  display: flex;
                "
              >

<!-- הצגת התמונה ישירות ב-TD של Preview -->
<img 
  v-if="art.svgFile && art.svgFile.relativePath"
  :src="store.baseURL + '/' + art.svgFile.relativePath"
  :style="{
    height: '47px',
    width: (47 * art.svgFile.pixelWidth / art.svgFile.pixelHeight) + 'px',
    objectFit: 'contain'
  }"
  alt="SVG Preview"
  @click="console.log('svgFile:', art.svgFile)"
/>
<!-- אם תרצה להחזיר את המבנה הישן, החזר את ה-TD וה-DIV -->


              <!-- <img :src="" style="position: relative"
                  :dwidth="
                    (47.0 *
                      art.sizes[Object.keys(art.sizes)[0]].svgFile.pixelWidth) /
                    art.sizes[Object.keys(art.sizes)[0]].svgFile.pixelHeight
                  "
                  :dheight="47.0"
                  :svgFile="art.sizes[Object.keys(art.sizes)[0]].svgFile"
                  :layersColors="art.defaultColors"
                  :left="0"
                  :top="0"> -->


                <!-- <DSTPreview
                  style="position: relative"
                  :dwidth="
                    (47.0 *
                      art.sizes[Object.keys(art.sizes)[0]].svgFile.pixelWidth) /
                    art.sizes[Object.keys(art.sizes)[0]].svgFile.pixelHeight
                  "
                  :dheight="47.0"
                  :svgFile="art.sizes[Object.keys(art.sizes)[0]].svgFile"
                  :layersColors="art.defaultColors"
                  :left="0"
                  :top="0"
                >
                </DSTPreview> -->
              </div>
            </td>
            <td>
              <icon-svg
                icon="line-md:edit"
                :height="25"
                :width="25"
                style="cursor: pointer"
                @click="editSvgArt(art)"
              />
            </td>
            <td>
              <icon-svg
                icon="ic:baseline-delete"
                :height="25"
                :width="25"
                style="cursor: pointer"
                @click="removeSvgArt(art.artID)"
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- SVG Edit Modal -->
<MDBModal v-model="editSvgPopup" v-if="SvgArtToPopup" centered scrollable>
  <MDBModalHeader>
    <MDBModalTitle>
      <div style="width: 100%; display: block">
        <span class="popup-title">
          <h4>{{ SvgArtToPopup.artName || 'New SVG Art' }}</h4>
        </span>
      </div>
    </MDBModalTitle>
  </MDBModalHeader>
  <MDBModalBody style="overflow-y: auto">
    <div>
      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>Art Name</td>
                <td>
                  <input class="form-control" type="text" v-model="SvgArtToPopup.artName" />
                </td>
              </tr>
              <tr>
                <td>SVG File</td>
                <td>
                  <!-- <input class="form-control" type="file" @change="updateSvgFile($event)" /> -->
                   <img 
                      v-if="SvgArtToPopup.svgFile && SvgArtToPopup.svgFile.relativePath"
                      :src="store.baseURL + '/' + SvgArtToPopup.svgFile.relativePath"
                      :style="{
                        height: '47px',
                        width: (47 * SvgArtToPopup.svgFile.pixelWidth / SvgArtToPopup.svgFile.pixelHeight) + 'px',
                        objectFit: 'contain'
                      }"
                      alt="SVG Preview"
                      @click="console.log('svgFile:', SvgArtToPopup.svgFile)"
                    />
                </td>
              </tr>
              <tr>
                <td>Category</td>
                <td>
                  <vue-select
                    :options="store.getAllSvgArtCategories()"
                    label-by="categoryName"
                    value-by="categoryID"
                    searchable
                    :model-value="SvgArtToPopup.artCategoryID"
                    @update:modelValue="(value) => {
                      if (value !== null && value !== undefined) {
                        SvgArtToPopup.artCategoryID = value
                      }
                    }"
                  />
                </td>
              </tr>
              <tr v-for="(color, index) in SvgArtToPopup.defaultColors" :key="index">
                <td>Color {{ index + 1 }}</td>
                <td>
                  <vue-select
                    :options="store.getAllSvgColors()"
                    label-by="colorName"
                    searchable
                    :model-value="currentSvgArtColors[index]"
                    @update:modelValue="val => { currentSvgArtColors[index] = val; setSvgColor(index, val); }"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </MDBModalBody>
  <MDBModalFooter>
    <MDBBtn color="secondary" @click="editSvgPopup = false">Close</MDBBtn>
    <MDBBtn color="primary" @click="saveSvgArt()">Save</MDBBtn>
  </MDBModalFooter>
</MDBModal>
      </MDBTabPane>
    </MDBTabContent>
  </MDBTabs>
</template>


<style scoped>
.prevArt {
  position: relative;
}
  .dd-color {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0px 10px;
  }
  .select-color-name {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: block;
  }

</style>

<script>
import { storeToRefs } from "pinia";
import { designerStore } from "@/stores/designerStore";
import DSTPreview from "./DSTPreview.vue";
import VueSelect from "vue-next-select";
// import SelectColor from "./SelectColor.vue";
import {
  MDBInput,
  MDBBtn,
  MDBModal,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBSpinner,
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane,
} from "mdb-vue-ui-kit";
import { ref } from "vue";

export default {
  setup() {
    const store = designerStore();
    const { artList } = storeToRefs(store);
    const editArtPopup = ref(false);
    const editArtSvgPopup = ref(false);
    const controlName = ref("EditArt");
    return {
      // you can return the whole store instance to use it in the template
      store,
      artList,
      editArtPopup,
      editArtSvgPopup,
      controlName,
    };
  },
  components: {
    DSTPreview,
    VueSelect,
    MDBInput,
    MDBBtn,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBSpinner,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
    // SelectColor
  },
  data() {
    return {
          SvgArtToPopup: {
      artName: '',
      artCategoryID: null,
      defaultColors: []
    },
       // כאן יושב האובייקט שאתה עורך
    currentSvgArtColors: [],
    editSvgPopup: false,
    //SvgArtToPopup: null,
      categoryName: "",
      
      artName: "",
      artCategoryID: null,
      artSizeName: "",
      contentDstFile: null,
      // newArtFile: null,
      newArtSizeName: null,
      newContentDstFile: null,
      // popupOpen: false,
      currentEditingArt: null,
      ArtToPopup: null,
      // popupCount: 0,
      currentArtColors: {},

      addSizeOpen: false,
      addSizeOpenCounter: 0,

      isLoading: false,
      showWaitMessage: false,

      artNameSvg: "",
      artCategoryIDSvg: null,
      contentDstFileSvg: null,
    };
  },
  methods: {
    addSvgArt() {
      // איפוס שדות הוספה בלבד (ללא עריכה)
      this.artNameSvg = '';
      this.artCategoryIDSvg = null;
      this.contentDstFileSvg = null;
      // אם תרצה להחזיר את הפופאפ לעריכה, בטל הערה מהשורה הבאה:
      // this.editSvgPopup = true;
    },
  saveSvgArt() {
    this.isLoading = true;
    // עדכון SVG Art – רק בפופאפ!
    if (this.SvgArtToPopup && this.SvgArtToPopup.artID) {
      this.store.updateSvgArt(this.SvgArtToPopup.artID, {
        artName: this.SvgArtToPopup.artName,
        artCategoryID: this.SvgArtToPopup.artCategoryID,
        // svgFile: this.contentDstFileSvg
        defaultColors: this.SvgArtToPopup.defaultColors
      });
      this.editSvgPopup = false;
    } else {
      // הוספה חדשה – רק מהאינפוטים למעלה
      this.store.newArtSvg(
        this.artNameSvg,
        this.contentDstFileSvg,
        this.artCategoryIDSvg
      );
      this.addSvgArt();
    }
    this.isLoading = false;
  },
    addArtCategory() {
      console.log(" color name = " + this.categoryName);
      this.store.addArtCategory(this.categoryName);
      this.categoryName = "";
    },
    
    addSvgArtCategory() {
      console.log(" color name = " + this.categoryName);
      this.store.addSvgArtCategory(this.categoryName);
      this.categoryName = "";
    },
    
    removeCategory(categoryId) {
      this.store.removeArtCategory(categoryId);
    },
    removeSvgArtCategory(categoryId) {
      this.store.removeSvgArtCategory(categoryId);
    },
    async newArt() {
      this.isLoading = true;
      await this.store.newArt(
        this.artName,
        this.contentDstFile,
        this.artSizeName,
        this.artCategoryID
      );
      this.isLoading = false;
    },

    GetAllSizesNames(art) {
      return Object.values(art.sizes)
        .filter((a) => a.isAvailable == true)
        .map((x) => x.sizeName)
        .join(" , ");
    },
    uploadNewArt(event) {
      const reader = new FileReader();
      reader.onload = () => {
        this.contentDstFile = reader.result;
      };

      reader.readAsDataURL(event.target.files[0]);
    },
    uploadNewArtSize(event) {
      const reader = new FileReader();
      reader.onload = () => {
        this.newContentDstFile = reader.result;
      };

      reader.readAsDataURL(event.target.files[0]);
    },
    uploadNewArtSvg(event) {
      const reader = new FileReader();
      reader.onload = () => {
        this.contentDstFileSvg = reader.result;
      };

      reader.readAsDataURL(event.target.files[0]);
    },

    removeArt(artID) {
      this.store.removeArt(artID);
    },
    removeSvgArt(artID) {
      this.store.removeSvgArt(artID);
    },
    editArt(art) {
      console.log("editArt", art);
      this.ArtToPopup = art;
      if(this.ArtToPopup.artCategoryID == undefined) {
        this.ArtToPopup.artCategoryID = null;
      }
      // this.popupOpen = true;
      this.currentArtColors = [];
      var allColorsDict = this.store.getAllColorsDict();
      for (var i = 0; i < (art.defaultColors ? art.defaultColors.length : 1); i++) {
        this.currentArtColors.push(allColorsDict[art.defaultColors[i]]);
      }
      // this.popupCount++;
    },
// addSvgArt() {
//   // יצירת אובייקט SVG חדש
//   const addSvgArt = {
//     artID: 4, // פונקציה ליצירת מזהה ייחודי
//     artName: "שם הארט",
//     svgFile: {/* נתוני הקובץ */},
//     defaultColors: [],
//     artCategoryID: null
//   };
//   this.store.allArtsSVG.value[addSvgArt.artID] = addSvgArt;
//   this.store.persistData(); // אם יש

//   // הוספה לעיצוב הנוכחי
//   const designArts = this.uStore.userDesigns[this.store.currentEditingProps.productId]
//     .designs[this.store.currentEditingProps.variantId]
//     .imgVariants[this.store.currentEditingProps.imageToPreview].arts;

//   designArts.push({
//     artID: addSvgArt.artID,
//     colors: addSvgArt.defaultColors,
//     dragTransform: {
//       x: 0,
//       y: 0,
//       width: 100,
//       height: 100,
//       scale: { scaleX: 1, scaleY: 1 },
//       rotate: 0
//     }
//     // שדות נוספים לפי הצורך
//   });
// },

editSvgArt(svgArt) {
  // שמירה ל-pop-up
    this.SvgArtToPopup = { ...svgArt }; // כאן מעתיקים את כל הנתונים לעריכה
      this.artCategoryIDSvg = svgArt.artCategoryID; // ⬅️ פה
  //this.artToPopup = svgArt;
  this.editSvgPopup = true;

  // בדיקה אם יש קטגוריה
  if (this.SvgArtToPopup.artCategoryID == undefined) {
    this.SvgArtToPopup.artCategoryID = null;
  }
  // אפס את הצבעים הקיימים
  this.currentSvgArtColors = [];

  // // אם יש צבעים, ממיר למערך עם שמות/אובייקטים מהסטור
  if (svgArt.defaultColors) {
    for (let i = 0; i < Object.keys(svgArt.defaultColors).length; i++) {
      this.currentSvgArtColors.push(this.store.getAllColors()[svgArt.defaultColors[i]]);
    }
  }

  // אפשר לפתוח פופ-אפ אם רוצים
  //  this.popupOpen = true;
   console.log("Popup opened");
}
,
    exitPopup() {
      this.popupOpen = false;
      this.newArtSizeName = "";
    },
    
    removeSize(artID, sizeID) {
      if (Object.values(this.store.allArts.value[artID].sizes).length > 1) {
        this.store.removeSize(artID, sizeID);
      } else {
        console.log("can not delete the last size");
      }
      // this.store.removeSize(artID, sizeID);
    },
    editSize(artID) {
      this.store.editSize(artID);
    },
    getArtName() {
      return this.artName;
    },
    setColor(index, value) {
      this.store.allArts.value[this.ArtToPopup.artID].defaultColors[index] =
        value.colorID;
    },
    setSvgColor(index, value) {
      this.store.allArtsSVG.value[this.ArtToPopup.artID].defaultColors[index] =
        value.colorID;
    },
    addArtSize() {
      this.addSizeOpen = true;
      this.addSizeOpenCounter++;
    },
    async addArtSizeToStore() {      
      this.showWaitMessage = true;
      await this.store.addArtSizeToStore(
        this.ArtToPopup.artID,
        this.newContentDstFile,
        this.newArtSizeName
      );
      this.showWaitMessage = false;
    },

  },
};
</script>

<style>
/* .vue-select-header {
  position: relative !important;
} */
</style>

